module.exports = __webpack_public_path__ + "static/img/about.14ed58b.14ed58b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about.14ed58b.png
// module id = SzqR
// module chunks = 1